export default __webpack_public_path__ + "static/media/0.4fb81038.png";